import React, { useMemo } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CssBaseline, ThemeProvider } from '@mui/material'
import App from './App'
import './styles/fonts.css'
import { ConfigUtils } from './util/configUtils'
import { SearchParams } from './enums/SearchParams'

function Root() {
  const theme = useMemo(
    () =>
      ConfigUtils.createThemeForOrganisationParam(
        new URLSearchParams(window.location.search).get(
          SearchParams.OrganisationId,
        ),
      ),
    [],
  )

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter basename="/financial-promotions">
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(<Root />)
